import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import config from "../../config";
import {
    helper1,
    helper2,
    helper3,
    payIcon,
    searchIcon,
    smileIcon,
    testimonial1,
    testimonial2,
    testimonial3,
} from "../../Constant";
import { GetServicesAction } from "../../redux/actions/services";
import { GetStatesAction } from "../../redux/actions/states";

const Home = ({ auth, services, getServices, getStates }) => {
    useEffect(() => {
        getStates().then(() => {
            getServices().then(() => {
                // console.log("got Data");
            });
        });
    }, []);
    return (
        <>
            <Header />
            <section className="our-supplements">
                <div className="container hero supplement">
                    <div className="row">
                        <div className="col-md-7 col-lg-7"></div>
                        <div className="col-md-5 col-lg-5">
                            <div className="box-view">
                                <div className="row equal">
                                    <div className="">
                                        <h4>Find the Best</h4>
                                        <div
                                            className="font-b font-weight-bold"
                                            style={{
                                                fontWeight: "900",
                                                lineHeight: "34px",
                                            }}
                                        >
                                            Personal Care Services
                                        </div>
                                        <p>
                                            Find trusted Care givers in
                                            affordable prices
                                        </p>
                                    </div>
                                </div>
                                <div className="container all-services-container">
                                    <div className="row text-center py-3 ">
                                        {services.map((service) => (
                                            <div
                                                className="col-md-4 box"
                                                key={service.id.toString()}
                                            >
                                                <Link
                                                    to={`/care-giver/${service.id}`}
                                                >
                                                    <div className="programs">
                                                        <img
                                                            src={
                                                                config.assetUrl +
                                                                "uploads/" +
                                                                service.image
                                                            }
                                                            className="pr-img"
                                                        />
                                                        <h5 className="head-p">
                                                            {service.title}
                                                        </h5>
                                                    </div>
                                                </Link>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="row py-3">
                                        <br />
                                        <div className="btn-element text-center d-flex home-Btn">
                                            {auth.loggedIn &&
                                            auth.user.role != 2 ? (
                                                <Link
                                                    to={
                                                        "/care-giver-registration"
                                                    }
                                                    className="orange btn btn-border padding-b find-job-btn"
                                                    target="_self"
                                                >
                                                    Become a Care Giver
                                                </Link>
                                            ) : null}
                                            <Link
                                                to="/care-giver"
                                                className="btn btn-secondary padding-b ml-1"
                                            >
                                                Find a Care Giver
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="program">
                <div className="container" style={{ padding: "40px" }}>
                    <div className="row text-center">
                        <div className="col-md-2"></div>
                        <div className="col-md-8">
                            <h4 className="grey">Welcome to</h4>
                            <h2>My Home Helper</h2>
                            <p>
                                My Home Helper is an all-in-one platform for
                                care seekers and care givers with a unified
                                approach to provide the highest quality of care
                                in the home sanctuary.
                            </p>
                        </div>

                        <div className="col-md-2"></div>
                    </div>
                </div>
                <div className="container" style={{ padding: "40px" }}>
                    <div className="row" id="ads">
                        <div className="col-md-4 home-card-mb">
                            <div className="card rounded h-100">
                                <div className="card-image">
                                    <img
                                        className="img-fluid"
                                        src={helper3}
                                        alt="Alternate Text"
                                    />
                                </div>
                                <div className="card-body">
                                    <div className="">
                                        <div className="row">
                                            <div className="col-md-12 col-sm-12">
                                                <a href="">
                                                    <h5>
                                                        Compassionate Caregivers
                                                    </h5>
                                                </a>{" "}
                                            </div>
                                        </div>
                                        <p>
                                            Our concerned caretakers have been
                                            scrupulously selected, screened, and
                                            trained to ensure our clients get
                                            exceptional services.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 home-card-mb">
                            <div className="card h-100 rounded">
                                <div className="card-image">
                                    <img
                                        className="img-fluid"
                                        src={helper2}
                                        alt="Alternate Text"
                                    />
                                </div>
                                <div className="card-body">
                                    <div className=" ">
                                        <div className="row">
                                            <div className="col-md-10">
                                                <a href="">
                                                    <h5>How does it work?</h5>
                                                </a>{" "}
                                            </div>
                                        </div>
                                        <p>
                                            Be it home care or personal care, we
                                            tailor our services to cater
                                            everyone's needs and situations.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            id="how-it-works"
                            className="col-md-4 home-card-mb"
                        >
                            <div className="card h-100 rounded">
                                <div className="card-image">
                                    <img
                                        className="img-fluid"
                                        src={helper1}
                                        alt="Alternate Text"
                                    />
                                </div>
                                <div className="card-body">
                                    <div className="">
                                        <div className="row">
                                            <div className="col-md-8">
                                                <a href="">
                                                    <h5>Our Process</h5>
                                                </a>{" "}
                                            </div>
                                        </div>
                                        <p>
                                            Our platform is designed to make the
                                            care process convenient &amp;
                                            hassle-free, while adhering to
                                            quality standards.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="healthy-sec text-center ">
                <div className="container">
                    <div className="row text-center py-5">
                        <div className="col-md-12">
                            <div className="programs ">
                                <h4>Easy to Hire</h4>
                                <h2>Family-Oriented Services</h2>
                            </div>
                        </div>
                    </div>
                    <div className="content-wrap ">
                        <div className="icon1 ">
                            <img src={searchIcon} alt="" height="200" />
                            <div className="programs">
                                <h4>Find a Suitable Care Giver</h4>
                                <p className="white">
                                    We give you complete liberty to search and
                                    evaluate all care givers and choose the most
                                    suitable one as per your need.
                                </p>
                            </div>
                        </div>
                        <div className="icon1 ">
                            <img src={payIcon} alt="" height="200" />
                            <div className="programs">
                                <h4>Book and Pay </h4>
                                <p className="white">
                                    Review ratings and comments and pay online
                                    for convenience!
                                </p>
                            </div>
                        </div>
                        <div className="icon1">
                            <img src={smileIcon} alt="" height="200" />
                            <div className="programs">
                                <h4>Just Chill</h4>
                                <p className="white">
                                    Once you have us on board, you can be rest
                                    assured of the quality of care to follow. We
                                    will take care of everything!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="testimonial">
                <div className="container" style={{ padding: "40px" }}>
                    <div className="row text-center">
                        <div className="col-md-12">
                            <h4 className="grey">Our Customers</h4>
                            <h2 className="orange">Our Pride</h2>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div
                        id="carouselExampleIndicators"
                        className="carousel slide"
                        data-ride="carousel"
                    >
                        <div className="carousel-inner d-flex">
                            <div className="carousel-item col-md-12 active">
                                <div className="row">
                                    <div className="col-lg-5 pl-0 pr-0">
                                        {" "}
                                        <img
                                            src={testimonial1}
                                            className="d-block w-100"
                                            height="450"
                                            alt="..."
                                        />{" "}
                                    </div>
                                    <div className="col-lg-7 ">
                                        <div className=" d-flex flex-column my-1 px-4 pt-5">
                                            <h4 className="name">
                                                Daniel Pearl, NY | USA{" "}
                                            </h4>
                                            <h2 className="head-t grey">
                                                Just in love with service.{" "}
                                            </h2>
                                            <div
                                                className=" justify-content-center"
                                                style={{
                                                    fontSize: "14px",
                                                    paddingTop: "10px",
                                                    paddingBottom: "10px",
                                                }}
                                            >
                                                What a great site! We have been
                                                looking for a long time for a
                                                caregiver for our elderly
                                                father, and it is so hard to
                                                find people with the right mix
                                                of skills, reliability, and
                                                compassion. Thank you for this
                                                great service!
                                            </div>
                                            <div className="rating pt-4">
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star"></span>
                                                <span className="fa fa-star"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item col-md-12">
                                <div className="row">
                                    <div className="col-lg-5 pl-0 pr-0">
                                        {" "}
                                        <img
                                            src={testimonial2}
                                            className="d-block w-100"
                                            height="450"
                                            alt="..."
                                        />{" "}
                                    </div>
                                    <div className="col-lg-7 ">
                                        <div className=" d-flex flex-column my-1 px-4 pt-5">
                                            <h4 className="name">
                                                Becky Moore, NY | USA{" "}
                                            </h4>
                                            <h2 className="head-t grey">
                                                Genuinely great people to work
                                                with!
                                            </h2>
                                            <div
                                                className=" justify-content-center"
                                                style={{
                                                    fontSize: "14px",
                                                    paddingTop: "10px",
                                                    paddingBottom: "10px",
                                                }}
                                            >
                                                Hi, I wanted to let you know
                                                that your service is amazing! I
                                                found a Caregiver for my
                                                daughter. She’s perfect! Thank
                                                you so much.
                                            </div>
                                            <div className="rating pt-4">
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star"></span>
                                                <span className="fa fa-star"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item col-md-12">
                                <div className="row">
                                    <div className="col-lg-5 pl-0 pr-0">
                                        {" "}
                                        <img
                                            src={testimonial3}
                                            className="d-block w-100"
                                            height="450"
                                            alt="..."
                                        />{" "}
                                    </div>
                                    <div className="col-lg-7 ">
                                        <div className=" d-flex flex-column my-1 px-4 pt-5">
                                            <h4 className="name">
                                                David Johnson, NY | USA{" "}
                                            </h4>
                                            <h2 className="head-t grey">
                                                Definitely My Home Helper!
                                            </h2>
                                            <div
                                                className=" justify-content-center"
                                                style={{
                                                    fontSize: "14px",
                                                    paddingTop: "10px",
                                                    paddingBottom: "10px",
                                                }}
                                            >
                                                As a small business owner, I was
                                                getting overworked with managing
                                                work and taking care of my baby.
                                                I needed a trustworthy nanny who
                                                could ensure that all the needs
                                                of my baby were adequately met.
                                                After searching for a while, I
                                                came across My home helper, and
                                                it’s been a great relief since
                                                then. I don’t have to
                                                continuously check on my
                                                babysitters and worry till I
                                                bite all my nails off. They have
                                                been a great help, and I can’t
                                                recommend them enough. So a Big
                                                Thank You to you guys.
                                            </div>
                                            <div className="rating pt-4">
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star"></span>
                                                <span className="fa fa-star"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ol className="carousel-indicators pl-1">
                            <li
                                data-target="#carouselExampleIndicators"
                                data-slide-to="0"
                                className="active"
                            ></li>
                            <li
                                data-target="#carouselExampleIndicators"
                                data-slide-to="1"
                            ></li>
                            <li
                                data-target="#carouselExampleIndicators"
                                data-slide-to="2"
                            ></li>
                        </ol>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    services: state.services,
});

const mapDispatchToProps = (dispatch) => ({
    getServices: async () => dispatch(await GetServicesAction()),
    getStates: async () => dispatch(await GetStatesAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
